const url = require('url');
const path = require('path');
const memoize = require('lodash/memoize');
const country = require('../l10n/country');

const EAGLE_URLS = [
  '/admin',
  '/checkout',
  '/mayday',
];

const EAGLE_MIGRATION_URLS = [
  '/checkout-v2',
];

const pathnameStartsWith = (pathname, urls) => {
  return !!urls.find(url => pathname.startsWith(url));
};

const isEagleUrl = memoize(pathname => {
  return pathnameStartsWith(pathname, EAGLE_URLS) && !pathnameStartsWith(pathname, EAGLE_MIGRATION_URLS);
});

const getPrefix = (countryModel, pathname) => {
  if (isEagleUrl(pathname)) {
    return country.isLegacyLocale(countryModel.locale) ? `/${countryModel.locale}` : `/en-US`;
  }
  return country.isDefault(countryModel) ? '/' : `/${countryModel.prefix}`;
};

const validateUrlObject = urlObject => {
  if (!urlObject.pathname.startsWith('/')) {
    throw new Error(`Urls must start with a slash: ${urlObject.pathname}`);
  }
};

const localiseUrl = (countryModel, inputUrl, removeTrailingSlash = true) => {
  const urlObject = url.parse(inputUrl, true);
  if (urlObject.pathname && !urlObject.protocol) {
    validateUrlObject(urlObject);
    const pathname = (getPrefix(countryModel, urlObject.pathname) + urlObject.pathname);
    urlObject.pathname = path.join('/', removeTrailingSlash ? pathname.replace(/\/$/, '') : pathname);
  }
  return url.format(urlObject);
};

const unlocaliseUrl = (countryModel, inputUrl) => {
  const urlObject = url.parse(inputUrl, true);
  if (urlObject.pathname) {
    validateUrlObject(urlObject);
    urlObject.pathname = path.join('/', urlObject.pathname.replace(getPrefix(countryModel, urlObject.pathname), ''));
  }
  return url.format(urlObject);
};

module.exports = {
  localiseUrl,
  unlocaliseUrl,
};



// WEBPACK FOOTER //
// ./src/common/utils/format-localised-url.js